export const GET_INVENTORY_REQUEST = "GET_INVENTORY_REQUEST";
export const GET_INVENTORY_SUCCESS = "GET_INVENTORY_SUCCESS";
export const GET_INVENTORY_FAIL = "GET_INVENTORY_FAIL";